export default "__VITE_ASSET__BrSWZJPq__"